'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;

var _Observable = require('rxjs/Observable');

require('rxjs/add/observable/fromEvent');

require('rxjs/add/observable/race');

require('rxjs/add/operator/filter');

require('rxjs/add/operator/map');

require('rxjs/add/operator/first');

require('rxjs/add/observable/merge');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var elements = {
    header: '.js-header',
    mobileNavBtns: '.js-mobile-nav-btns',
    topNav: '.js-top-nav',
    primaryNav: '.js-primary-nav',
    primaryNavContainer: '.js-primary-nav-container',
    hamburger: '.js-hamburger',
    searchForm: '.js-nav-search-form'
};

var primaryNavBtns = '.js-primary-btn';
var subNavList = [];

var delegateClasses = {
    searchBtn: 'js-nav-search',
    primaryNavBtn: 'js-primary-btn',
    hamburger: 'js-hamburger',
    backBtn: 'js-mobile-back',
    closeArea: 'js-nav-close-area'
};

var activeClasses = {
    subNav: 'subnav-active',
    mobile: 'mobile-active',
    sticky: 'sticky',
    generic: 'active',
    headerOpen: 'is-open',
    searchOpen: 'search-active'
};

var state = {
    isSubNavOpen: false,
    isSearchOpen: false,
    currentSubNav: null,
    isSetOpen: false
};

var breakpoint = 1024;

function init() {
    elements.header = document.querySelector(elements.header);
    if (!elements.header) {
        return;
    }

    var elementKeys = Object.keys(elements);
    elements = elementKeys.filter(function (el) {
        return el !== 'header';
    }).reduce(function (acc, key) {
        acc[key] = document.querySelector(elements[key]);
        return acc;
    }, {
        header: elements.header
    });

    primaryNavBtns = document.querySelectorAll(primaryNavBtns);
    primaryNavBtns = Array.prototype.slice.call(primaryNavBtns);
    subNavList = [elements.searchForm].concat(_toConsumableArray(primaryNavBtns), [elements.topNav, elements.primaryNavContainer]);

    subNavList = subNavList.filter(function (el) {
        return !!el;
    });

    var click = _Observable.Observable.fromEvent(elements.header, 'click');
    var mouseOver = _Observable.Observable.fromEvent(elements.header, 'mouseover');
    var focusOut = _Observable.Observable.fromEvent(document, 'focusin');
    var focusOn = _Observable.Observable.fromEvent(elements.header, 'focusin').map(function (evt) {
        if (!evt.target.classList.contains('js-primary-btn')) {
            var container = evt.target.closest('.js-primary-btn-container');
            return {
                target: container && container.querySelector('.js-primary-btn') || evt.target
            };
        }

        return evt;
    });

    click.filter(function (el) {
        return el.target.classList && el.target.classList.contains(delegateClasses.searchBtn);
    }).subscribe(openSearchForm);

    _Observable.Observable.fromEvent(elements.header, 'focusin').filter(function (evt) {
        return evt.target.closest('.js-nav-search-form') && !state.isSearchOpen;
    }).subscribe(openSearchForm);

    click.filter(function (el) {
        return el.target.classList && el.target.classList.contains(delegateClasses.hamburger);
    }).subscribe(openMobileNav);

    click.filter(function (el) {
        return el.target.classList && window.innerWidth <= breakpoint && el.target.classList.contains(delegateClasses.primaryNavBtn);
    }).map(function (evt) {
        return evt.preventDefault(), evt;
    }).subscribe(openSubNav);

    click.filter(function (el) {
        return el.target.classList && el.target.classList.contains(delegateClasses.backBtn);
    }).map(function (evt) {
        return evt.preventDefault(), evt;
    }).subscribe(openMobileSubNav);

    mouseOver.filter(function (el) {
        return el.target.classList && window.innerWidth > breakpoint && el.target.classList.contains(delegateClasses.primaryNavBtn);
    }).subscribe(openSubNav);

    mouseOver.filter(function (el) {
        return el.target.classList && window.innerWidth > breakpoint && el.target.classList.contains(delegateClasses.closeArea);
    }).subscribe(closeNav);

    focusOn.filter(function (el) {
        return el.target.classList && window.innerWidth > breakpoint && el.target.classList.contains(delegateClasses.closeArea);
    }).subscribe(closeNav);

    focusOn.filter(function (el) {
        return el.target.classList && window.innerWidth > breakpoint && el.target.classList.contains(delegateClasses.primaryNavBtn);
    }).subscribe(openSubNav);

    focusOut.filter(function (evt) {
        return window.matchMedia('(min-width: 1024px)').matches && !evt.target.closest('.js-primary-nav') && !(evt.target.classList.contains('js-nav-search') && state.isSearchOpen);
    }).subscribe(closeNav);
}

function openSubNav(evt) {
    openNav();

    if (state.currentSubNav !== evt.target) {
        closeSubNav(evt.target);
        state.currentSubNav = evt.target;
        state.currentSubNav.classList.add(activeClasses.generic);
        var subnavEl = state.currentSubNav.parentNode.querySelector('.c-primary-nav__subnav');

        if (subnavEl) {
            transitionEndObserver(subnavEl).first().filter(function () {
                return !state.isSetOpen;
            }).subscribe(function () {
                state.isSetOpen = true;
                elements.header.classList.add(activeClasses.headerOpen);
            });
        }
    }
}

function transitionEndObserver(element) {
    return _Observable.Observable.race(_Observable.Observable.fromEvent(element, 'webkitTransitionEnd'), _Observable.Observable.fromEvent(element, 'transitionend'), _Observable.Observable.fromEvent(element, 'msTransitionEnd'), _Observable.Observable.fromEvent(element, 'oTransitionEnd'));
}

function closeSubNav() {
    var ignore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if (ignore && !Array.isArray(ignore)) {
        ignore = [ignore];
    }

    if (state.isSearchOpen) {
        if (!~ignore.indexOf(elements.searchForm)) {
            state.isSearchOpen = false;
            elements.header.classList.remove(activeClasses.searchOpen);
        }
    }

    subNavList.filter(function (el) {
        if (!ignore) {
            return true;
        }

        return !~ignore.indexOf(el);
    }).forEach(function (el) {
        el.classList.remove(activeClasses.generic);
    });
}

function openSearchForm() {
    openNav();
    if (state.currentSubNav !== elements.searchForm) {
        closeSubNav(elements.searchForm);
        state.isSearchOpen = true;
        elements.header.classList.add(activeClasses.searchOpen);

        elements.searchForm.classList.add(activeClasses.generic);
        state.currentSubNav = elements.searchForm;
        var input = elements.searchForm.querySelector('input');
        input.focus();

        if (elements.hamburger.classList.contains(activeClasses.generic)) {
            elements.hamburger.classList.remove(activeClasses.generic);
        }
    } else {
        closeNav();
    }
}

function openMobileNav() {
    if (state.isSearchOpen || !state.isSubNavOpen) {
        openMobileSubNav();
        elements.hamburger.classList.add(activeClasses.generic);
    } else if (window.innerWidth <= breakpoint && elements.hamburger.classList.contains(activeClasses.generic)) {
        elements.hamburger.classList.remove(activeClasses.generic);
        closeNav();
    }
}

function openMobileSubNav() {
    openNav();
    if (state.currentSubNav !== elements.primaryNavContainer) {
        state.currentSubNav = elements.primaryNavContainer;
        closeSubNav([elements.topNav, elements.primaryNavContainer]);
        elements.topNav && elements.topNav.classList.add(activeClasses.generic);
        elements.primaryNavContainer && elements.primaryNavContainer.classList.add(activeClasses.generic);
    }
}

function openNav() {
    if (!state.isSubNavOpen) {
        state.isSubNavOpen = true;
        elements.header.classList.add(activeClasses.subNav);
        elements.header.classList.add(activeClasses.mobile);
    }
}

function closeNav() {
    if (state.isSubNavOpen) {
        state.isSubNavOpen = false;
        elements.header.classList.remove(activeClasses.subNav);
        elements.header.classList.remove(activeClasses.mobile);
        elements.header.classList.remove(activeClasses.headerOpen);
        state.currentSubNav = null;
        state.isSetOpen = false;
        closeSubNav();
    }
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/nav.js
// module id = ./resources/assets/js/src/ui/nav.js
// module chunks = 0